module.exports = __webpack_public_path__ + "img/Droplii_logo-green.13baf1d9.png";